import CompanyInfoContainer from './CompanyInfoContainer';

export default CompanyInfoContainer;
